import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: {
          position: 'fixed',
          display: 'block',
          width: '45px',
          height: '45px',
          lineHeight: '48px',
          right: '0',
          top: '30%',
          backgroundColor: '#222834',
          textAlign: 'center',
          cursor: 'pointer',
          borderRadius: '5px 0 0 5px',
        },
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.show && _ctx.show(...args)))
    }, [
      _createVNode(_component_SettingOutlined, { style: { fontSize: '20px', color: '#fcfcfc' } })
    ]),
    _createVNode(_component_a_drawer, {
      title: "系统布局配置",
      visible: _ctx.visible,
      onClose: _ctx.close,
      bodyStyle: { padding: '10px' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_list, { size: "small" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_list_item, null, {
              actions: _withCtx(() => [
                _createVNode(_component_a_switch, {
                  checked: _ctx.topNavEnable,
                  onChange: _ctx.onChangeTopNavEnable
                }, null, 8, ["checked", "onChange"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 启用顶部导航 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_list_item, null, {
              actions: _withCtx(() => [
                _createVNode(_component_a_switch, {
                  checked: _ctx.headFixed,
                  onChange: _ctx.onChangeHeadFixed,
                  disabled: _ctx.disabledHeadFixed
                }, null, 8, ["checked", "onChange", "disabled"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 固定右侧头部 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_list_item, null, {
              actions: _withCtx(() => [
                _createVNode(_component_a_switch, {
                  checked: _ctx.tabNavEnable,
                  onChange: _ctx.onChangeTabNavEnable
                }, null, 8, ["checked", "onChange"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 启用TabNav ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ], 64))
}